import { useState } from "react";
import { useWidth } from "../../../../hooks/useWidht";
import { Modal } from "../../../../shared/components/Modal/Modal";
import styles from "./PrivacyPoliteModal.module.css";

type Props = {
    isOpen: boolean;
    onClose: () => void;
};
export const PrivacyPoliteModal = ({ isOpen, onClose }: Props) => {
    const width = useWidth();
    const isMobile = width <= 767;
    const isTablet = width >= 768 && width <= 1024;
    const widthModal = isMobile ? "90%" : isTablet ? "80%" : "60%";
    const heightModal = isMobile ? "90%" : isTablet ? "85%" : "85%";
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            width={widthModal}
            height={heightModal}
        >
            <div className={styles.modalContent}>
                <iframe
                    src="https://politica-privacidad-permulink.netlify.app/"
                    title="Privacy Policy Modal"
                    className={styles.iframe}
                    color="white"
                    onLoad={() => setIsLoading(false)}
                />
                {isLoading && (
                    <div className={styles.loading}>
                    <div className={styles.spinner}></div>
                        <span>Cargando...</span>
                    </div>
                )}
                <button onClick={onClose} className={styles.closeButton}>
                    Cerrar
                </button>
            </div>
        </Modal>
    );
};
